import { atom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { AUTHENTICATE_TOKEN_KEY, AUTHENTICATE_USER_KEY } from 'app/config'
import { User } from 'types/User'
import { AuthToken } from 'app/services/api'

export const currentUserAtom = atomWithStorage<User | null>(
  AUTHENTICATE_USER_KEY,
  null,
  createJSONStorage<User | null>(() => localStorage),
  { getOnInit: true },
)

export const accessTokenAtom = atomWithStorage<AuthToken | null>(
  AUTHENTICATE_TOKEN_KEY,
  null,
  createJSONStorage<AuthToken | null>(() => localStorage),
  { getOnInit: true },
)

export const isAuthenticatedAtom = atom(false)
